import React from 'react';

const CurrentStatus = () => {
  return (
    <div className="bg-white p-4 rounded-lg shadow mb-4">
      <h2 className="text-xl font-medium mb-3">Current Status</h2>
      <ul className="space-y-2">
        <li className="flex items-start">
          <span className="mr-2">•</span>
          <span className="font-medium">Disease:</span>
          <span className="ml-2">Metastatic to liver, stable</span>
        </li>
        <li className="flex items-start">
          <span className="mr-2">•</span>
          <span className="font-medium">Treatment:</span>
          <span className="ml-2">FOLFOX + Bevacizumab</span>
        </li>
        <li className="flex items-start">
          <span className="mr-2">•</span>
          <span className="font-medium">Last scan:</span>
          <span className="ml-2">Oct 15, 2023 - Stable</span>
        </li>
        <li className="flex items-start">
          <span className="mr-2">•</span>
          <span className="font-medium">Performance status:</span>
          <span className="ml-2">ECOG 1</span>
        </li>
      </ul>
    </div>
  );
};

export default CurrentStatus;
